export const sanitizeTextForUTF8 = (input: string) => {
  return input
    // Replace narrow no-break space (U+202F) with regular space
    .replace(/\u202F/g, ' ')
    // Replace non-breaking space (U+00A0) with regular space
    .replace(/\u00A0/g, ' ')
    // Replace en dash (–) and em dash (—) with regular hyphen
    .replace(/[\u2013\u2014]/g, '-')
    // Optionally normalize quotes or other characters if needed
    .replace(/[\u2018\u2019]/g, "'")   // Single quotes
    .replace(/[\u201C\u201D]/g, '"');  // Double quotes
}